module.exports = __webpack_public_path__ + "static/media/East-Lincolnshire.f3c4abb2.pdf";